import { TableViewConfig } from '@creditsights/styleguide-web';
import { DateRenderer } from '../../../formatters';

export const TABLE_CONFIG: TableViewConfig = {
  columns: [
    {
      dataKey: 'meetingDate',
      headerName: 'Meeting Date',
      cellDataRenderer: DateRenderer,
    },
    {
      dataKey: 'dealType',
      headerName: 'Deal Type',
    },
    {
      dataKey: 'booksClosed',
      headerName: 'Books Close',
      cellDataRenderer: DateRenderer,
    },
    {
      dataKey: 'size',
      headerName: 'Size (m)',
    },
    {
      dataKey: 'uop',
      headerName: 'UOP',
    },
  ],
};
